interface ScheduleRowIdentity {
    id: string;
    scheduleApplicationId?: string;
}

export function getScheduleRowApplicationId(row: ScheduleRowIdentity): string {
    return row.scheduleApplicationId ?? row.id;
}

export function getUniqueScheduleApplicationIds(
    rows: ScheduleRowIdentity[],
): string[] {
    return [...new Set(rows.map(getScheduleRowApplicationId))];
}

export function getSingleScheduleEntityId(
    rows: Array<{ entityId: number }>,
): number | null {
    const entityIds = new Set(rows.map((row) => row.entityId));
    return entityIds.size === 1 ? rows[0].entityId : null;
}
